import { Link, useNavigate } from "react-router-dom";
import Pagination from "../../Services/Pagination";
import EventsSubMenus from "./EventsSubMenus";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import moment from "moment";
import { setMainLoading, setPageTitle } from "../../Store/reducers/Common";
import { PostAxios, responseCatchFunc } from "../../Services/RequestService";
import { EVENT_TYPE_FILTER_OPTIONS, EVENT_TYPE_LABEL_MAP } from "./constants";
import DatePicker from "react-date-picker";
import { ConvertErrorArrayToString } from "../../Services/Common";
import { setToastData } from "../../Store/reducers/Toast";

const PastEventsList = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { userData, accessToken } = useSelector((state) => state.user);
    const [showFilter, setShowFilter] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationData, setPaginationData] = useState({ total: 0, per_page: 20 });
    const [filter, setFilter] = useState({
        org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id,
        div_id: userData.role_slug === "super_admin" ? 0 : userData.user_div,
        event_type: "all",
        from_date: "",
        to_date: "",
    });
    const [orgList, setOrgList] = useState([]);
    const [divList, setDivList] = useState([]);
    const [eventList, setEventList] = useState([]);
    const [eventTypeDraftMap, setEventTypeDraftMap] = useState({});
    const filterHandler = (key, value) => {
        setFilter({ ...filter, [key]: value });
    }
    useEffect(() => {
        dispatch(setPageTitle(`Past Events`));
        dispatch(setMainLoading(true));
        let promiseArray = [];
        if (userData.role_slug === "super_admin") {
            promiseArray.push(PostAxios(`masters/organization`, { page: 1, perPage: 1000 }, accessToken));
        }
        if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
            promiseArray.push(PostAxios(`masters/division-list`, { org_id: userData.role_slug === "super_admin" ? 0 : userData.org_id, page: 1, perPage: 1000 }, accessToken));
        }
        if (promiseArray.length > 0) {
            Promise.all(promiseArray)
                .then((response) => {
                    if (response[0].config.url === "masters/organization") {
                        if (response[0].data.status === "1") {
                            setOrgList(response[0].data.data);
                        }
                    }
                    else {
                        if (response[0].data.status === "1") {
                            setDivList(response[0].data.data);
                        }
                    }
                    if (response?.[1]?.config?.url === "masters/division-list") {
                        if (response[1].data.status === "1") {
                            setDivList(response[1].data.data);
                        }
                    }
                    runFilter();
                })
                .catch(err => {
                    console.log(err);
                })
        }
        else {
            runFilter();
        }
    }, [accessToken, userData]);
    const filteredDivList = useMemo(() => {
        let tempL = [];
        let orgId = parseInt(filter.org_id);
        for (let div of divList) {
            if (parseInt(div.org_id) === orgId || orgId === 0) {
                tempL.push(div);
            }
        }
        return tempL;
    }, [filter.org_id, divList]);
    const runFilter = (pageNo = 0) =>{
        dispatch(setMainLoading(true));
        setEventList([]);
        let postData = {
            ...filter
        }
        if (pageNo > 0) {
            postData.page = pageNo
            postData.perPage = paginationData.per_page
        }
        PostAxios(`event/past-event-list`, postData, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    if (data?.totalRecords) {
                        setPaginationData({ total: data?.totalRecords, per_page: data?.perPage });
                    }
                    setEventList(data.data);
                    const draftMap = {};
                    data.data.forEach((item) => {
                        draftMap[item.id] = item.event_type || "local";
                    });
                    setEventTypeDraftMap(draftMap);
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err)
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            })
    }
    const updatePastEventType = (eventId) => {
        const selectedType = eventTypeDraftMap[eventId] || "local";
        dispatch(setMainLoading(true));
        PostAxios(`event/update-past-event-type`, { event_id: eventId, event_type: selectedType }, accessToken)
            .then(({ data }) => {
                if (data.status === "1") {
                    dispatch(setToastData({ message: data.message, isHtml: true, type: 'success', showCloseBtn: true }));
                    runFilter(currentPage);
                } else {
                    dispatch(setToastData({
                        message: (data.errors) ? ConvertErrorArrayToString(data.errors) : data.message,
                        isHtml: true,
                        type: 'error',
                        showCloseBtn: true
                    }));
                }
            })
            .catch((err) => {
                responseCatchFunc(dispatch, err);
            })
            .finally(() => {
                dispatch(setMainLoading(false));
            });
    };
    return <>
        <EventsSubMenus />
        <div className="main-form-sec">
            {
                (userData.role_slug === "super_admin" || userData.role_slug === "org_admin" || userData.role_slug === "captain" || userData.role_slug === "div_admin" || userData.caps_list.includes('add_event')) &&
                <div className="top-right-btn p-0">
                    <Link
                        to={"/events/add"}
                        className="btn-blue btn br-0"
                    >
                        Add New Event
                    </Link>
                </div>
            }
            <div className="top-reports-filter">
                <div className={`right-filter-sec`}>
                    <button className="filter-toggle" onClick={() => {
                        setShowFilter(!showFilter);
                    }}>
                        <i className="fa-solid fa-filter"></i>
                    </button>
                    <div className={`p-0 filter-search form-field-group report-filter  ${(showFilter) ? '' : 'filter-active'}`}>
                        {
                            userData.role_slug === "super_admin" &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Organization</label>
                                <div className="static-items-outer">
                                    <select
                                        id="org_id"
                                        name="org_id"
                                        className="select-input"
                                        value={filter.org_id}
                                        onChange={(e) => setFilter({ ...filter, "org_id": e.target.value, div_id: 0 })}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            orgList.length > 0 && orgList.map((item, index) => <option key={`org-${index}`} value={item.ID}>{item.short_name}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        {
                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Division</label>
                                <div className="static-items-outer">
                                    <select
                                        id="div_id"
                                        name="div_id"
                                        className="select-input"
                                        value={filter.div_id}
                                        onChange={(e) => filterHandler("div_id", e.target.value)}
                                    >
                                        <option value='0'>All</option>
                                        {
                                            filteredDivList.length > 0 && filteredDivList.map((item, index) => <option key={`div-list-${index}`} value={item.ID}>{item.division_name} {`(${item.division_number})`}</option>)
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        {
                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                            <div className="report-filter-field">
                                <label className="select-input-outer">Event Type</label>
                                <div className="static-items-outer">
                                    <select
                                        id="event_type"
                                        name="event_type"
                                        className="select-input"
                                        value={filter.event_type}
                                        onChange={(e) => filterHandler("event_type", e.target.value)}
                                    >
                                        {
                                            EVENT_TYPE_FILTER_OPTIONS.map((item) => (
                                                <option key={`event-type-${item.value}`} value={item.value}>{item.label}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            </div>
                        }
                        <div className="report-filter-field form-field-group">
                            <label className="select-input-outer">From Date</label>
                            <div className="date-picker-sec">
                                <DatePicker
                                    className="form-input"
                                    clearIcon={null}
                                    format="dd-MM-y"
                                    dayPlaceholder="DD"
                                    monthPlaceholder="MM"
                                    yearPlaceholder="YYYY"
                                    value={filter.from_date ? new Date(filter.from_date) : null}
                                    onChange={(val) => filterHandler("from_date", val ? moment(val).format("YYYY-MM-DD") : "")}
                                />
                            </div>
                        </div>
                        <div className="report-filter-field form-field-group">
                            <label className="select-input-outer">To Date</label>
                            <div className="date-picker-sec">
                                <DatePicker
                                    className="form-input"
                                    clearIcon={null}
                                    format="dd-MM-y"
                                    dayPlaceholder="DD"
                                    monthPlaceholder="MM"
                                    yearPlaceholder="YYYY"
                                    minDate={filter.from_date ? new Date(filter.from_date) : null}
                                    maxDate={new Date()}
                                    value={filter.to_date ? new Date(filter.to_date) : null}
                                    onChange={(val) => filterHandler("to_date", val ? moment(val).format("YYYY-MM-DD") : "")}
                                />
                            </div>
                        </div>
                        <button type="button" className="btn btn-blue ms-2" onClick={() => { setCurrentPage(1); runFilter(1); }}>Submit</button>
                    </div>
                </div>
            </div>
            <div className="table-wrapper">
                <table className="table">
                    <thead>
                        <tr>
                            <th>S.No.</th>
                            <th>Title</th>
                            <th>Event Type</th>
                            <th>Location</th>
                            <th style={{ minWidth: 130 }}>Date & Time</th>
                            <th style={{ minWidth: 110 }}>Mohalla</th>
                            <th style={{ minWidth: 90 }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            eventList.length > 0 && eventList.map((item, index) => {
                                let divName = '';
                                if (parseInt(item.event_user_div) === 0) {
                                    divName = 'All';
                                }
                                else if (item?.div_name_list.trim() !== "") {
                                    let splitDNl = item.div_name_list.split(';');
                                    for (let i of splitDNl) {
                                        let splitDn = i.split('|');
                                        if (parseInt(splitDn[0]) === parseInt(userData.user_div)) {
                                            divName = splitDn[1];
                                            break;
                                        }
                                        else if (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") {
                                            if (divName !== "") {
                                                divName += ', ';
                                            }
                                            divName += splitDn[1];
                                        }
                                    }
                                }
                                else if (parseInt(item.event_user_div) === parseInt(userData.user_div)) {
                                    divName = item.division_name;
                                }
                                return <tr key={`event-item-${index}`}>
                                    <td>{(currentPage - 1) * paginationData.per_page + index + 1}</td>
                                    <td>{item.event_title}</td>
                                    <td>{EVENT_TYPE_LABEL_MAP[item.event_type] || "Local"}</td>
                                    <td>{item.event_location}</td>
                                    <td>
                                        {moment(`${item.event_start_date} ${item?.event_start_time}`).format('DD MMM YY h:mm a')}
                                        &nbsp; - &nbsp;
                                        {moment(`${item.event_end_date} ${item?.event_end_time}`).format('DD MMM YY h:mm a')}
                                    </td>
                                    <td>{divName}</td>
                                    <td>
                                        {
                                            (userData.role_slug === "super_admin" || userData.role_slug === "org_admin") &&
                                            <div className="d-flex align-items-center mb-2">
                                                <select
                                                    className="select-input"
                                                    style={{ minWidth: 150, height: 34, fontSize: 13 }}
                                                    value={eventTypeDraftMap[item.id] || "local"}
                                                    onChange={(e) => {
                                                        setEventTypeDraftMap({
                                                            ...eventTypeDraftMap,
                                                            [item.id]: e.target.value
                                                        });
                                                    }}
                                                >
                                                    <option value="local">Local</option>
                                                    <option value="safar">Safar</option>
                                                    <option value="intl">International Miqaat</option>
                                                </select>
                                                <button
                                                    type="button"
                                                    className="btn btn-blue btn-sm ms-2"
                                                    title="Update Event Type"
                                                    onClick={() => updatePastEventType(item.id)}
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        }
                                        <button type="button" className="btn-blue btn btn-sm ms-2" title="View Event" onClick={() => {
                                            navigate('/events/view', { state: { event_id: item.id } });
                                        }}>
                                            <i className="fa-solid fa-eye"></i>
                                        </button>
                                    </td>
                                </tr>
                            })
                        }
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={currentPage}
                totalCount={paginationData.total}
                pageSize={paginationData.per_page}
                onPageChange={page => {
                    setCurrentPage(page);
                    runFilter(page);
                }}
            />
        </div>
    </>
}

export default PastEventsList;